export const getFormattedDate = (date: Date, includeTime = false) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  if (includeTime) {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }
  return `${year}-${month}-${day}`;
};

export const getStartOfDay = (date: string | number | Date) => {
  const startOfDay = new Date(date);
  startOfDay.setHours(0, 0, 0, 0);
  return startOfDay;
};

export const getEndOfDay = (date: string | number | Date) => {
  const endOfDay = new Date(date);
  endOfDay.setHours(23, 59, 59, 999);
  return endOfDay;
};

const today = new Date();
const yesterday = new Date(today);
yesterday.setDate(yesterday.getDate() - 1);

export const calculateDateRange = (range: any) => {
  const now = new Date();
  switch (range) {
    case 'today': {
      const todayStart = getStartOfDay(now);
      const todayEnd = getEndOfDay(now);
      return {
        startDate: getFormattedDate(todayStart, true),
        endDate: getFormattedDate(todayEnd, true),
      };
    }
    case 'yesterday': {
      const yesterdayDate = new Date(now);
      yesterdayDate.setDate(now.getDate() - 1);
      const yesterdayStart = getStartOfDay(yesterdayDate);
      const yesterdayEnd = getEndOfDay(yesterdayDate);
      return {
        startDate: getFormattedDate(yesterdayStart, true),
        endDate: getFormattedDate(yesterdayEnd, true),
      };
    }
    case 'last7days': {
      const last7days = new Date(now);
      last7days.setDate(now.getDate() - 7);
      const last7daysStart = getStartOfDay(last7days);
      const nowEnd = getEndOfDay(now);
      return {
        startDate: getFormattedDate(last7daysStart, true),
        endDate: getFormattedDate(nowEnd, true),
      };
    }
    case 'last30days': {
      const last30days = new Date(now);
      last30days.setDate(now.getDate() - 30);
      const last30daysStart = getStartOfDay(last30days);
      const nowEnd = getEndOfDay(now);
      return {
        startDate: getFormattedDate(last30daysStart, true),
        endDate: getFormattedDate(nowEnd, true),
      };
    }
    default: {
      const yesterdayStart = getStartOfDay(yesterday);
      const nowEnd = getEndOfDay(now);
      return {
        startDate: getFormattedDate(yesterdayStart, true),
        endDate: getFormattedDate(nowEnd, true),
      };
    }
  }
};

export const timeRanges = [
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'Last 7 Days', value: 'last7days' },
  { label: 'Last 30 Days', value: 'last30days' },
];
